"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
exports.TestAndNb = t.interface({
    testId: t.string,
    nb: t.number
});
exports.PaymentBody = t.interface({
    token: t.string,
    amount: t.number,
    currency: t.keyof({ eur: null }),
    description: t.string,
    source: t.string,
    tests: t.array(exports.TestAndNb)
});
exports.PaymentResponse = t.interface({
    paid: t.boolean
});
//# sourceMappingURL=payment.js.map


//////////////////
// WEBPACK FOOTER
// ../models/dist/api/payment.js
// module id = 725
// module chunks = 12